import type { StyleRule } from '@archipro-design/aria';
import {
    avatarClassName,
    buttonClassName,
    captionClassName,
    labelClassName,
    pxArrayToRem,
    pxToRem,
} from '@archipro-design/aria';

export const ContentContainer: StyleRule = ({ theme, expanded }) => ({
    borderTop: `1px solid ${theme.siteVariables.colors.grey['100']}`,
    padding: pxArrayToRem([16, 18, 15, 18]),
    width: '100%',
    cursor: expanded ? 'unset' : 'pointer',
    '&:hover': {
        backgroundColor: '#E8E9EB',
    },

    [theme.screen.min.tablet]: {
        padding: pxArrayToRem([16, 10, 15, 10]),
    },
});

export const LocationBaseInfoContainer: StyleRule = () => ({
    width: '100%',
    [`& .${avatarClassName}`]: {
        width: pxToRem(47),
        height: pxToRem(47),
        minWidth: pxToRem(47),
    },
});

export const ProfessionalInfoContainer: StyleRule = () => ({
    marginLeft: pxToRem(16),
    padding: pxArrayToRem([4, 0, 3, 0]),
    flex: 1,
});

export const ProfessionalTitle: StyleRule = ({ theme }) => ({
    ...theme.siteVariables.textStyles.Text.Medium65,
    letterSpacing: '-0.01em',
    color: theme.siteVariables.colors.primitive.black,
});

export const Address: StyleRule = ({ theme }) => ({
    ...theme.siteVariables.textStyles.Text.Roman55,
    color: '#717171',
});

export const LocationInfoContainer: StyleRule = () => ({
    padding: pxArrayToRem([2, 0, 5, 0]),
    alignItems: 'end',
});

export const Distance: StyleRule = ({ theme }) => ({
    ...theme.siteVariables.textStyles.Text.Roman55,
    color: theme.siteVariables.colors.charcoal[250],
    marginLeft: pxToRem(4),
});

export const ExpandButton: StyleRule = ({ theme }) => ({
    ...theme.siteVariables.textStyles.Text.Roman55,
    color: theme.siteVariables.colors.charcoal[100],
});

export const LocationDetailContainer: StyleRule = ({ theme }) => ({
    padding: pxArrayToRem([28, 0, 36, 63]),
    [`& > .${buttonClassName}`]: {
        [`& > .${labelClassName}`]: {
            fontSize: pxToRem(16),
            lineHeight: pxToRem(20.8),
            color: theme.siteVariables.colors.charcoal[250],
            textDecoration: 'underline',
        },
    },

    [`& .${captionClassName}`]: {
        lineHeight: pxToRem(20.8),
    },
    [theme.screen.min.tablet]: {
        padding: pxArrayToRem([30, 0, 29, 63]),
    },
});

export const LocationType: StyleRule = ({ theme }) => ({
    ...theme.siteVariables.textStyles.Text.Medium65,
    letterSpacing: '-0.01em',
    color: theme.siteVariables.colors.primitive.black,
});

export const LocationInfo: StyleRule = ({ theme }) => ({
    marginTop: pxToRem(5),
    ...theme.siteVariables.textStyles.Text.Roman55,
    color: theme.siteVariables.colors.charcoal[250],
});
